module.exports = __webpack_public_path__ + "static/media/atlassian.c10373be.svg";